import { ROUTE_PATH } from "@/common/constants/routing";
import { AppPermission, VehicleDto, VehicleReferenceDto } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import VehicleInline, { VehicleInlineProps } from "./VehicleInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: VehicleDto | VehicleReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<VehicleInlineProps>;
}

export default function VehicleLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  if (!entity && !entityId) {
    return null;
  }

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.VehicleRead]}
      to={ROUTE_PATH.VEHICLE_VIEW(entity?.id || entityId || "")}
      content={<VehicleInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
